if (!customElements.get('steps-carousel')) {
  class StepsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.steps-section__items');
      this.dots = Array.from(this.querySelectorAll('.steps-section__dot'));
      this.steps = this.track ? Array.from(this.track.children) : [];

      if (!this.track || !this.dots.length || !this.steps.length) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const step = this.steps[index];
          if (!step) return;
          this.track.scrollTo({
            left: step.offsetLeft - this.track.offsetLeft,
            behavior: 'smooth',
          });
        });
      });

      this.handleScroll = this.handleScroll.bind(this);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });

      // Set correct dot on initial load
      this.updateActiveFromScroll();
    }

    handleScroll() {
      if (this.rafId) window.cancelAnimationFrame(this.rafId);
      this.rafId = window.requestAnimationFrame(() => this.updateActiveFromScroll());
    }

    updateActiveFromScroll() {
      const trackRect = this.track.getBoundingClientRect();
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.steps.forEach((step, index) => {
        const stepRect = step.getBoundingClientRect();
        const distance = Math.abs(stepRect.left - trackRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.setActive(closestIndex);
    }

    setActive(index) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
      if (this.rafId) window.cancelAnimationFrame(this.rafId);
    }
  }

  customElements.define('steps-carousel', StepsCarousel);
}